import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import FormatCurrency from 'components/Common/FormatCurrency'
import { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import LoyaltyTierBenefitAvailabilityMessageBanner from 'loyalty/components/LoyaltyTierBenefitAvailabilityMessageBanner'
import React from 'react'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

interface Props {
  image: App.Image
  benefitValue: number
}

function LandingPageLoyaltyTourExpCreditBenefitsModal(props: Props) {
  const { image, benefitValue } = props

  return (
    <ModalBase size="L">
      <ModalHeader title="Extras on your tour" />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            <LoyaltyTierBenefitAvailabilityMessageBanner benefitType="tour_exp_credit" />
            <BodyText variant="large">
              Enjoy extra perks on your next adventure with a travel credit towards tour add-ons.{' '}
              Whether it’s a sunset cruise or a food tour, these extras are on us.
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">How it works</Heading>
              <BodyText variant="large">
                Enhance your immersive small-group adventure with <FormatCurrency value={benefitValue} format="dynamic" /> to spend on optional extras.{' '}
                Whether it’s a handpicked cultural experience or a special add-on, you can customise your{' '}
                journey to suit your style.<br /><br />
                With exclusive tours designed by our travel experts and a dedicated tours concierge to assist,{' '}
                it’s seamless from start to finish.<br /><br />
                To activate, purchase a Luxury Escapes tour and contact customer service and we'll organise your voucher.
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyTourExpCreditBenefitsModal
